import { useQuery } from '@tanstack/react-query';

import { formatDateToISO, normalizeToStartOfDayUTC } from '@/utils/date-formatters';
import { normalizeToEndOfDayUTC } from '@/utils/date-formatters/date-formatters';

import { getWeekOverview } from '../api/time-tracking.api';
import { TIME_TRACKING_QUERY_KEYS } from '../constants/time-tracking-query-keys';
import { ViewMode } from '../types/time-tracking';
import { getDateRangeForView } from './use-view-mode-and-date';

interface UseWeekOverviewParams {
  /** Any date inside the target week. */
  date: Date;
}

export const useWeekOverview = ({ date }: UseWeekOverviewParams) => {
  const { start, end } = getDateRangeForView(date, ViewMode.Week);
  const startDate = formatDateToISO(normalizeToStartOfDayUTC(start));
  const endDate = formatDateToISO(normalizeToEndOfDayUTC(end));

  return useQuery({
    queryKey: TIME_TRACKING_QUERY_KEYS.weekOverview(startDate, endDate),
    queryFn: () => getWeekOverview(startDate, endDate),
    staleTime: 1000 * 60 * 5,
  });
};
